interface DeleteDraftBodyArgs {
  rounds: number;
  /** Undefined while unknown (the roster failed to load). */
  players: number | undefined;
  /** Undefined while unknown, or when the league has no teams at all. */
  teams: number | undefined;
  /** Team and Scramble leagues; Individual leagues never mention teams. */
  hasTeams: boolean;
}

function count(n: number, noun: string): string {
  return `${n} ${noun}${n === 1 ? "" : "s"}`;
}

/**
 * The sentence naming what a draft delete takes with it. It only claims what
 * it has read: an unknown roster count drops the numbers rather than saying
 * "0 players" about a roster it never saw.
 */
export function deleteDraftBody({
  rounds,
  players,
  teams,
  hasTeams,
}: DeleteDraftBodyArgs): string {
  const lead = "This draft and everything set up in it will be deleted: ";
  const tail = " This cannot be undone.";

  if (players === 0) {
    return `${lead}its settings and its ${count(rounds, "round")}.${tail}`;
  }

  if (players === undefined) {
    const roster = hasTeams ? "roster and any teams" : "roster";
    return `${lead}its settings, ${count(rounds, "round")}, ${roster}.${tail}`;
  }

  const roster = `roster of ${count(players, "player")}`;
  const withTeams = !hasTeams
    ? roster
    : teams === undefined
      ? `${roster} and any teams`
      : teams > 0
        ? `${roster} and ${count(teams, "team")}`
        : roster;
  return `${lead}its settings, ${count(rounds, "round")}, ${withTeams}.${tail}`;
}
